'use client';

import * as React from 'react';
import mixpanel from 'mixpanel-browser';

export default function EventViewBusiness() {
  React.useEffect(() => {
    mixpanel.track('business_landing_viewed');
  }, []);

  return null;
}
